import React from "react";
import MyContainer from "@/components/MyContainer";
import { LinkButton } from "@/components/ui/buttons/link-button";
import { useLocation } from "wouter";
import { routes } from "@/routes/route-constants";
import FulfillmentAsyncTable from "./component/fulfillment-async-table";

export default function FulfillmentPage() {
  const [, setLocation] = useLocation();

  const handleCreate = () => {
    setLocation(routes.fulfillment.new());
  };

  return (
    <MyContainer
      title="Pickup and Delivery"
      enableBack={false}
      subtitle="Manage your pickup and delivery"
      actions={<LinkButton label="Pickup and Delivery" onClick={handleCreate} />}
    >
      <FulfillmentAsyncTable />
    </MyContainer>
  );
}
